import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardFlightComponent } from './card-flight.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
@NgModule({
  declarations: [CardFlightComponent],
  imports: [CommonModule, SharedModule, PipesModule],
  exports: [CardFlightComponent]
})
export class CardFlightModule {}
